import { render, staticRenderFns } from "./SoTTable.vue?vue&type=template&id=60674d38&"
import script from "./SoTTable.vue?vue&type=script&lang=js&"
export * from "./SoTTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports